'use client';
import env from '@platform-ui/utilities/env.js';
import posthog, { CaptureResult } from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

export function isCefSharpException(event: CaptureResult | null): boolean {
  return (
    event?.event === '$exception' &&
    event.properties &&
    typeof event.properties.$exception_message === 'string' &&
    event.properties.$exception_message.includes('Object Not Found Matching Id')
  );
}

const {
  REACT_APP_PUBLIC_POSTHOG_KEY: posthogProjectAPIKey,
  REACT_APP_PUBLIC_POSTHOG_HOST: posthogAPIUrl,
} = env();

if (typeof window !== 'undefined' && posthogProjectAPIKey && posthogAPIUrl) {
  posthog.init(posthogProjectAPIKey, {
    api_host: posthogAPIUrl,
    person_profiles: 'identified_only',
    capture_pageview: false, // Disable automatic pageview capture, as we capture manually
    capture_pageleave: true, // Enable pageleave capture
    opt_in_site_apps: true,
    before_send: (event) => {
      if (isCefSharpException(event)) {
        return null; // Discard the event
      }

      return event;
    },
  });
}

export function PHProvider({ children }) {
  return <PostHogProvider client={posthog}> {children} </PostHogProvider>;
}

/**
 * Posthog feature flags are defined and configured in the Posthog Dashboard.
 * Each relevant project in posthog must define the feature flag.
 */
export const POSTHOG_FEATURE_FLAGS = {
  caseWorkflowImprovements: 'case-workflow-improvements',
  hidePartnerPortalRedirect: 'hide-partner-portal-redirect',
  hidePasswordSignin: 'hide-password-signin',
  idleSessionTimeout: 'session-timeouts',
  introPagesNavigation: 'intro-pages-navigation',
  resubmissionRequests: 'resubmission-requests',
  applicationDiffs: 'application-diffs',
  // Temporary San Mateo content flag
  tempSanMateoClaimContent: 'temp-san-mateo-claim-content',
};

export const POSTHOG_EVENTS = {
  sessionIdleRecovery: 'SessionIdleRecovery',
  sessionIdleTimeout: 'SessionIdleTimeout',
};
